export const translateStaticContent = (key, defaultStaticContent, activeLangStaticContent) => {
    if (defaultStaticContent !== undefined) {
        if (activeLangStaticContent !== undefined) {
            return activeLangStaticContent[key] ? activeLangStaticContent[key] : defaultStaticContent[key]
        } else {
            return defaultStaticContent[key]
        }
    } 
  }
